import { initializeTemplates, availableFontNames } from '~/lib/pdf'
import * as Style1 from './Style1'
import * as Style2 from './Style2'

const [templates, templateStyle, templateSupportedStyles] = initializeTemplates(
  [Style1, Style2],
)

export { templates, templateStyle, templateSupportedStyles, availableFontNames }
